import { createContext, useContext, useEffect, useState } from "react";
import portalApi from "@/lib/portalApi";

const ClientAuthContext = createContext(null);

export function ClientAuthProvider({ children }) {
  const [client, setClient] = useState(null);

  useEffect(() => {
    if (!localStorage.getItem("vl_client_token")) { setClient(false); return; }
    portalApi.get("/portal/me")
      .then(({ data }) => setClient(data))
      .catch(() => { localStorage.removeItem("vl_client_token"); setClient(false); });
  }, []);

  const signIn = (data) => { localStorage.setItem("vl_client_token", data.token); setClient(data.client); };
  const login = async (email, password) => { const { data } = await portalApi.post("/portal/login", { email, password }); signIn(data); };
  const activate = async (token, password) => { const { data } = await portalApi.post("/portal/activate", { token, password }); signIn(data); };
  const logout = () => { localStorage.removeItem("vl_client_token"); setClient(false); };

  return <ClientAuthContext.Provider value={{ client, login, activate, logout }}>{children}</ClientAuthContext.Provider>;
}

export const useClientAuth = () => useContext(ClientAuthContext);
